<div id="case-attachments" class="container-fluid pb-3">

    <div class="row" *ngIf="case">

        <!-- LEFT COLUMN WITH LIST -->

        <div class="col-sm-4">

            <mat-card>
                <mat-card-content>

                    <!-- Below template is passed on to the action list to replace the default appearance -->
                    <ng-template #customActionListTemplate
                                 let-documentType="data">
                        <span class="action-list-display-name" *ngIf="documentType">
                            {{ documentType.actionListDisplayName | translate }}
                            <span *ngIf="getDocumentCountForCategory(documentType.key)"
                                  class="mat-badge-content mat-badge-active document-count-badge"
                                  [ngClass]="{'selected': documentType === selectedDocumentType}">
                                {{getDocumentCountForCategory(documentType.key)}}
                            </span>
                        </span>

                    </ng-template>

                    <action-list [idPrefix]="idPrefix"
                                 [items]="documentTypes"
                                 [template]="customActionListTemplate"
                                 [selected]="selectedDocumentType"
                                 [identifier]="'key'"
                                 (select)="selectDocumentType($event)">
                    </action-list>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-sm-8">
            <mat-card>
                <mat-card-content>
                    <div class="smp-title">{{ selectedDocumentType ? (selectedDocumentType.trans | translate) : '' }}</div>

                    <div class="row no-gutters" style="margin-top: 25px;">
                        <case-files-upload class="full-width"
                                           *ngIf="case && fileMetaCategoryList"
                                           [idPrefix]="idPrefix"
                                           [caseId]="case.id"
                                           [(fileMetaCategoryList)]="fileMetaCategoryList"
                                           [smpFileCategory]="selectedDocumentType.key"
                                           [dropzoneLabel]="'common.label.add' | translate : { name: (selectedDocumentType.trans | translate) }"
                                           [addButtonLabel]="'common.label.add' | translate : { name: (selectedDocumentType.trans | translate) }"
                                           [acceptedFiles]="acceptedFileTypes"
                                           [hasContent]="fileMetaCategoryList?.getFilesByCategory(selectedDocumentType.key)?.entries.length > 0">

                            <!-- only works with a dropzone. List is displayed inside the dropzone (if it has files) -->

                            <case-files-list *ngIf="selectedDocumentType.key !== CaseFileCategory.CLAIM_IMAGE.key"
                                             class="full-width"
                                             [idPrefix]="idPrefix"
                                             [caseId]="case.id"
                                             [(fileMetaCategoryList)]="fileMetaCategoryList"
                                             [smpFileCategory]="selectedDocumentType.key"
                                             [labelProp]="'whoAndWhen'">
                            </case-files-list>

                            <case-files-thumbnails-list *ngIf="selectedDocumentType.key === CaseFileCategory.CLAIM_IMAGE.key"
                                                        class="full-width"
                                                        [idPrefix]="idPrefix"
                                                        [caseId]="case.id"
                                                        [(fileMetaCategoryList)]="fileMetaCategoryList"
                                                        [smpFileCategory]="selectedDocumentType.key"
                                                        [labelProp]="'whoAndWhen'">
                            </case-files-thumbnails-list>

                        </case-files-upload>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>

    </div>

</div>
